import { schema } from 'normalizr';

export const rawMatSupplierSchema = new schema.Entity('rawMatSuppliers', {}, { idAttribute: 'RawMatSupplierId' });
export const rawMatSupplierListSchema = [rawMatSupplierSchema];
